import PropTypes from 'prop-types';
import React from 'react';
import { DatePicker } from '@opendate-app/setlist';

const toDate = (value) => (value ? new Date(`${value}T00:00:00`) : null);

const toValue = (date) => (
  (date instanceof Date && !Number.isNaN(date.getTime()))
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    : ''
);

const DateCustomFieldValue = ({ customFieldValue, customFieldValueChanged, idSuffix }) => {
  const customField = customFieldValue.custom_field;
  const id = `custom-field-date-${customField.id}${idSuffix ? `-${idSuffix}` : ''}`;

  return (
    <div className="mt-3 mb-3">
      <DatePicker
        id={id}
        label={customField.required ? customField.name : `${customField.name} (optional)`}
        value={toDate(customFieldValue.value)}
        onChange={(date) => customFieldValueChanged({ ...customFieldValue, value: toValue(date) })}
      />
    </div>
  );
};

DateCustomFieldValue.propTypes = {
  customFieldValue: PropTypes.object.isRequired,
  customFieldValueChanged: PropTypes.func.isRequired,
  idSuffix: PropTypes.string,
};

DateCustomFieldValue.defaultProps = {
  idSuffix: null,
};

export default DateCustomFieldValue;
